import ContentBox from "../../ContentBox/ContentBox";

export default function BeaExpertStatusReport() {
  return (
    <ContentBox headline="Status des beA-Systems">
      <iframe
        src="https://bea.expert/bea-stoerung/"
        title="beA-System Status"
        width="100%"
        height="800px"
        style={{ border: "none" }}
      />

      <a href={"https://bea.expert/bea-stoerung"} target={"_blank"}>
        beA-Status Seite in neuem Tab öffnen
      </a>

    </ContentBox>
  );
}
